import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';

export const NotFound: React.FC = () => {
  const location = useLocation();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: '6rem', fontWeight: 700, color: 'text.secondary', mb: 1 }}>
          404
        </Typography>
        <Typography variant="h4" component="h1" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Typography variant="body2" color="text.disabled" sx={{ mb: 4, fontFamily: 'monospace' }}>
          {location.pathname}
        </Typography>
        <Button
          component={RouterLink}
          to="/home"
          variant="contained"
          size="large"
        >
          Go to Home
        </Button>
      </Box>
    </Container>
  );
};
